export default __webpack_public_path__ + "static/media/color-wheel-re-export.03242174.jpg";